import { get, post, put, remove } from '../services/common/common.service';
import { billingEndpoints } from '../constants/endpoint';

//billing tool history tab api
export const getHistory = (payload) => {
  return get(
    `${billingEndpoints.getHistory}?customerBillId=${payload.customerBillId}&recordCount=${payload.recordCount}&pageIndex=${payload.pageIndex}`
  );
};

export const getBillingData = (payload) => {
  return post(billingEndpoints.billingSearch, payload);
};

export const fetchBillingStatus = (payload) => {
  return get(
    `${billingEndpoints.billingStatus}?fetchOnlyForPendingBill=${payload}`
  );
};

export const setApprovBills = (payload) =>
  post(billingEndpoints.approvBills, payload);

// billing setup and update apis

// 1] latest api for country grid data call on go button
export const getCpiByCountry = (payload) => {
  return post(billingEndpoints.getCountry, payload);
};

// 2]search cpi by country and to get cpidefault country griddata
export const searchCpiByCountry = (payload) => {
  if (payload?.countryName) {
    return get(
      `${billingEndpoints.searchCpiByCountry}?countryName=${payload.countryName}&recordCount=${payload.recordCount}&pageIndex=${payload.pageIndex}`
    );
  } else if (payload?.countryCode) {
    return get(
      `${billingEndpoints.searchCpiByCountry}?countryCode=${payload.countryCode}&recordCount=${payload.recordCount}&pageIndex=${payload.pageIndex}`
    );
  } else if (payload?.recordCount && payload?.pageIndex) {
    return get(
      `${billingEndpoints.searchCpiByCountry}?&recordCount=${payload.recordCount}&pageIndex=${payload.pageIndex}`
    );
  }
};

// 3]continue save api

export const continueCpi = (payload) => {
  return put(billingEndpoints.continue, payload);
};

//4]cpi setup tab grid data
export const searchCPISetupTabData = (payload) => {
  return post(billingEndpoints.searchCpiSetupTab, payload);
};

//5]latest update contract cpi percentage
export const updateContractCpi = (payload) => {
  return put(billingEndpoints.updateContractCpi, payload);
};

//6]remove cpi setup tab grid row data
export const removeCpi = (payload) => {
  return remove(billingEndpoints.removeCpi, payload);
};

//7]reset erase for date steps
export const resetCpi = (payload) => {
  return remove(`${billingEndpoints.reset}?effectiveDate=${payload}`, payload);
};

//8]cpi history tab
export const getCpiHistory = (payload) => {
  return get(
    `${billingEndpoints.getCpiHistory}?recordCount=${payload.recordCount}&pageIndex=${payload.pageIndex}`
  );
};

export const fetchBillingContractDetails = (payload) => {
  return get(
    `${billingEndpoints.billingContractDetails}?customerId=${payload}`
  );
};

export const fetchBillingGridData = (payload) => {
  return get(
    `${billingEndpoints.billingGridData}?customerBillId=${payload.customerBillId}&userId=${payload.userId}&recordCount=${payload.recordCount}&pageIndex=${payload.pageIndex}`
  );
};

export const fetchBillingDetailsTabData = (payload) => {
  return get(
    `${billingEndpoints.billingDetailsTabData}?customerBillId=${payload.customerBillId}&pageIndex=${payload.pageIndex}&recordCount=${payload.recordCount}`
  );
};

export const fetchBillingNoteData = (payload) => {
  return get(
    `${billingEndpoints.getBillingNotes}?customerBillId=${payload.customerBillId}&isBillLine=${payload.isBillLine}&recordCount=${payload.recordCount}&pageIndex=${payload.pageIndex}`
  );
};

export const fetchBillingLineDdData = (payload) => {
  return get(
    `${billingEndpoints.getBillingLineDD}?customerBillId=${payload.customerBillId}`
  );
};

export const addBillingNoteLineHeader = (payload) => {
  return post(billingEndpoints.addBillingNoteLineHeader, payload);
};

export const regenerateBill = (payload) => {
  return post(billingEndpoints.regenerateBill, payload);
};

//billing lockdown
//9]
export const putCpiSetupLockDown = (payload) => {
  return put(
    `${billingEndpoints.putCpiSetupLockDown}?effectiveDate=${payload.effective_Date}&lastModifiedUserId=${payload.lastModifiedUserId}`
  );
};

//10]
export const getCpiSetupLockDown = (payload) => {
  return get(
    `${billingEndpoints.getCpiSetupLockDown}?effectiveDate=${payload}`
  );
};
